<template>
  <div class="table-expand-data">
    <table-form-span
      v-for="(field, index) in scope.row.fields"
      :key="index"
      :formItems="formItems"
      :formVal="field"
      :initValue="false"
      :inline="true"
    ></table-form-span>
  </div>
</template>
<script>
export default {
  name: 'table-expand-data',
  props: {
    scope: Object,
  },
  computed: {},
  data() {
    return {
      formItems: [
        {
          label: '列名称: ',
          prop: 'clum_desc',
        },
        {
          label: '查询列: ',
          prop: 'query_clum',
          format: (val) => {
            return val ? '是' : '否'
          },
        },
        {
          label: '文本框: ',
          prop: 'ele_type',
          format: (val) => {
            return val ? '是' : '否'
          },
        },
        {
          label: '排序值: ',
          prop: 'clum_sort',
        },
      ],
    }
  },
  methods: {
    unBindCLick() {
      this.$emit('unBindCLick', this.scope)
    },
  },
}
</script>

<style lang="stylus" scoped>
>>>.el-form-item {
  width: 24%;
  margin-bottom: 0;
}
</style>